var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { styled } from "@mui/system";
import { Button } from "../Button";
import { Grid } from "@mui/material";
const FooterWrapper = styled("div")(({ theme }) => {
    return {
        ".progInfoFooter": {
            background: "#f7f7f7",
            borderTop: "1px solid #bdbdbd",
            padding: "20px",
            boxShadow: "0 2px 4px 0 #e5e5e5, 0 1px 2px 0 #bdbdbd",
            borderRadius: "0 0 4px 4px",
        },
        ".footerText": {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "end",
            padding: "9px 15px 0 0",
        },
        ".leftSectionbuttons": {
            alignItems: "center",
            display: "flex",
        },
        p: {
            margin: 0,
            fontFamily: "Roboto",
            fontSize: 14,
            fontWeight: 400,
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.14,
            letterSpacing: "normal",
            textAlign: "right",
            color: "#333",
            padding: "2px 0",
        },
        ".dpFlex": {
            display: "flex",
        },
        [theme.breakpoints.down(475)]: {
            ".progInfoFooter": {
                padding: "10px",
            },
            // '.leftSectionbuttons':{
            //   justifyContent:'center'
            // }
        },
    };
});
export const ProgramInfoFooter = (props) => {
    const { label } = props, rest = __rest(props, ["label"]);
    const handleClickEvents = (btn) => {
        props.handleCallback && props.handleCallback(Object.assign({}, btn));
    };
    return (React.createElement(FooterWrapper, Object.assign({}, rest),
        React.createElement(Grid, { container: true, className: "progInfoFooter" },
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement("div", { className: "leftSectionbuttons" }, (props === null || props === void 0 ? void 0 : props.leftSectionbuttons) &&
                    (props === null || props === void 0 ? void 0 : props.leftSectionbuttons.map((btn) => (React.createElement(Button, Object.assign({ key: btn.label }, btn, { onClick: () => handleClickEvents(btn) }))))))),
            props.rightSectionText !== "" && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement("div", { className: "footerText" },
                    React.createElement("div", null,
                        React.createElement("p", { style: { fontWeight: "700" } }, "Need help?"),
                        React.createElement("p", { style: { whiteSpace: "pre-line" } }, props.rightSectionText)),
                    props.showChatIcon && React.createElement(props.showChatIcon, null)))))));
};
